import { IconAlertCircle } from '@tabler/icons-react';
import { useQuery } from '@tanstack/react-query';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Badge } from '@/components/ui/badge';
import { Spinner } from '@/components/ui/spinner';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { relativeTime } from '@/lib/utils';
import { api } from '../api.js';

export function WorkspacesPage() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['workspaces'],
    queryFn: api.workspaces,
  });

  return (
    <div className="mx-auto flex max-w-5xl flex-col gap-4">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold tracking-tight">Workspaces</h1>
        {data && <Badge>{data.workspaces.length}</Badge>}
      </div>

      {isLoading && (
        <div className="flex items-center gap-2">
          <Spinner />
          <span className="text-sm text-muted-foreground">
            Loading workspaces…
          </span>
        </div>
      )}

      {error && (
        <Alert tone="destructive">
          <IconAlertCircle />
          <AlertTitle>Failed to load workspaces</AlertTitle>
          <AlertDescription>{error.message}</AlertDescription>
        </Alert>
      )}

      {data && data.workspaces.length === 0 && (
        <p className="py-12 text-center text-sm text-muted-foreground">
          No workspaces yet.
        </p>
      )}

      {data && data.workspaces.length > 0 && (
        <div className="rounded-md border border-neutral-800 bg-card">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Workspace</TableHead>
                <TableHead>Owner</TableHead>
                <TableHead>Host</TableHead>
                <TableHead>Last access</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {data.workspaces.map((w) => (
                <TableRow key={w.client}>
                  <TableCell className="font-mono">{w.client}</TableCell>
                  <TableCell>{w.owner ?? '—'}</TableCell>
                  <TableCell>{w.host ?? '—'}</TableCell>
                  <TableCell className="text-muted-foreground">
                    {relativeTime(w.accessAt)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
}

